import {connect} from 'react-redux'
import {DispatchProps, MapContainer, mapStateToProps, OwnProps} from '../../core/components/Map/MapContainer'

import {ILayersDispatcher} from '../../core/interfaces/dispatchers'
import {appLayersDispatcher} from '../../dispatchers/appLayersDispatcher'

class AppMapContainer extends MapContainer {}

export default connect<OwnProps, DispatchProps & ILayersDispatcher, {}>(mapStateToProps, {...appLayersDispatcher})(
  AppMapContainer
)
